export const hasViewId = (views, viewId) => {
  if (!Array.isArray(views) || !viewId) return false;
  return views.some((view) => view?.id && view.id === viewId);
};

export const resolveEffectiveViewId = (collection, fallbackViewId = null) => {
  const views = Array.isArray(collection?.views) ? collection.views : [];

  if (!views.length) {
    return null;
  }

  const currentUserActiveViewId = collection?.currentUserActiveViewId || null;
  const defaultViewId = collection?.defaultViewId || null;

  if (hasViewId(views, currentUserActiveViewId)) {
    return currentUserActiveViewId;
  }

  if (hasViewId(views, defaultViewId)) {
    return defaultViewId;
  }

  if (hasViewId(views, fallbackViewId)) {
    return fallbackViewId;
  }

  return views[0]?.id || null;
};

export const resolveEffectiveView = (collection, fallbackViewId = null) => {
  const views = Array.isArray(collection?.views) ? collection.views : [];
  const effectiveViewId = resolveEffectiveViewId(collection, fallbackViewId);

  if (!effectiveViewId) {
    return views[0] || null;
  }

  return views.find((view) => view?.id === effectiveViewId) || views[0] || null;
};
